import { BrowserRouter, Routes, Route } from "react-router-dom";

import Screen1Email from "./screens/Screen1Email";
import Screen2Password from "./screens/Screen2Password";
import Screen3Posts from "./screens/Screen3Posts";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Screen1Email />} />
        <Route path="/password" element={<Screen2Password />} />
        <Route path="/posts" element={<Screen3Posts />} />
      
      </Routes>
    </BrowserRouter>
  );
}

export default App;